/*单位概况-看板*/
export default [{
  //用电服务
  path: '/usePowerUnit',
  name: 'usePowerUnit',
  component: () =>
    //  import('@/page/yuexin/ranking.vue')//越亚
    import('@/page/unitKanBan/usePowerUnit.vue')//通用
  //  import('@/page/hengqin/usePowerUnit.vue') //横琴看板
  //  import('@/page/unitKanBan/nanjingRwstUnitKanBan.vue') //南京瑞沃思通
  //  import('@/page/unitKanBan/shengchan.vue') //生产看板
  // import('@/page/projectDingZhi/fangzheng/usePowerUnit.vue')
},
{
  //生产看板
  path: '/produceBoard',
  name: 'produceBoard',
  component: () =>
    //import('@/page/unitKanBan/temp.vue')
    import('@/page/unitKanBan/shengchan.vue')
},
{
  //务联看板(左三右三)
  path: '/wulianKanban',
  name: 'wulianKanban',
  component: () =>
    //import('@/page/unitKanBan/temp.vue')
    import('@/page/unitKanBan/wulianKanban.vue')
},
{
  //务联看板(横)
  path: '/wuliankanbanC',
  name: 'wuliankanbanC',
  component: () =>
    //import('@/page/unitKanBan/temp.vue')
    import('@/page/unitKanBan/wuliankanbanC.vue')
},
{
  //温度在线
  path: '/temperatureOverView',
  name: 'temperatureOverView',
  component: () =>
    import('@/page/system/temperature/temperatureOverView.vue')
},
{
  //设备监测
  path: '/deviceLine',
  name: 'deviceLine',
  component: () =>
    import('@/page/system/temperature/deviceLine.vue')
},
{
  //设备监测
  path: '/newdeviceLine',
  name: 'newdeviceLine',
  component: () =>
    import('@/page/system/temperature/newdeviceLine.vue')
}, {
  //运维报告
  path: '/maintenanceReport',
  name: 'maintenanceReport',
  component: () =>
    import('@/page/unitKanBan/maintenanceReport.vue')
},
{
  //智慧安全用电
  path: '/zhydHome',
  name: 'zhydHome',
  component: () =>
    import('@/page/system/zhanyd/zhydHome.vue')
},
{
  //看板管理
  path: '/kanBanManage',
  name: 'kanBanManage',
  component: () =>
    import('@/page/unitKanBan/kanBanManage.vue')
},
{
  //自定义看板
  path: '/customKanBan',
  name: 'customKanBan',
  component: () =>
    import('@/page/unitKanBan/customKanBan.vue')
},
{
  //首页看板(保存自定义看板之后所启用的看板)
  path: '/homeKanBan',
  name: 'homeKanBan',
  component: () =>
    import('@/page/unitKanBan/homeKanBan.vue')
}, {
  //中山全胜
  path: '/quanShengKanBan',
  name: 'quanShengKanBan',
  component: () =>
    import('@/page/projectDingZhi/quanSheng/usePowerUnit.vue')
}, {
  //德茵电气
  path: '/deyinUnitOverview',
  name: 'deyinUnitOverview',
  component: () =>
    import('@/page/projectDingZhi/deyin/unitOverview/index.vue')
}, {
  //德茵看板
  path: '/deyinKanBan',
  name: 'deyinKanBan',
  component: () =>
    import('@/page/projectDingZhi/deyin/unitOverview/usePowerUnit.vue')
}, {
  //杭州东杰
  path: '/dongJieOverview',
  name: 'dongJieOverview',
  component: () =>
    import('@/page/projectDingZhi/dongjie/dongJieOverview.vue')
}, {
  //中科泛在
  path: '/UbiquitousOverview',
  name: 'UbiquitousOverview',
  component: () =>
    import('@/page/projectDingZhi/Ubiquitous/UbiquitousOverview.vue')
}, {
  //珠海一格
  path: '/yigeUnitKanBan',
  name: 'yigeUnitKanBan',
  component: () =>
    import('@/page/unitKanBan/yigeUnitKanBan.vue')
},
// {
// 	//天澄定制看板
// 	path: '/unitBoard',
// 	name:'unitBoard',
// 	component: () =>
// 		//import('@/page/unitKanBan/temp.vue')
// 		import('@/page/unitKanBan/TcKanBan1.vue')
// 	//import('@/page/unitKanBan/demo1.vue')
// },
{
  //德肯虚拟电厂看板
  path: '/virtualPowerPlant',
  name: 'virtualPowerPlant',
  component: () =>
    import('@/page/unitKanBan/virtualPowerPlant.vue')
  //import('@/page/unitKanBan/demo1.vue')
},
{
  //充放电看板
  path: '/bulletinBoard',
  name: 'bulletinBoard',
  component: () =>
    import('@/page/unitKanBan/bulletinBoard.vue')
  //import('@/page/unitKanBan/demo1.vue')
},
{
  //德肯虚拟电厂光伏
  path: '/photovoltaic',
  name: 'photovoltaic',
  component: () =>
    import('@/page/unitKanBan/guangfu.vue')
},
{
  //德肯虚拟电厂储能
  path: '/energyStorage',
  name: 'energyStorage',
  component: () =>
    import('@/page/unitKanBan/cuneng.vue')
},
{
  //机场看板
  path: '/airportKanban',
  name: 'airportKanban',
  component: () =>
    import('@/page/airport/airportKanban.vue')
},
]